/* eslint-disable id-length */
import { TimelineLite, TweenLite } from 'gsap'
import { easing } from './Core'
import config from '../Config'
import { isMobile } from '../Helpers/device'

export const chatBtnWidth = ({ target, options }) => {
  const currentBtn = target[0].className.split('--')[1]

  let iconFrom
  let iconTo

  if (currentBtn === 'start') {
    iconFrom = '.lc-launcher__close-icon'
    iconTo = '.lc-launcher__chat-icon'
  } else {
    iconFrom = '.lc-launcher__chat-icon'
    iconTo = '.lc-launcher__close-icon'
  }

  return new TimelineLite()
    .add('btnWidth')
    .to(
      currentBtn,
      config.launcherAnimSpeed,
      {
        width: options.btnWidths[currentBtn],
        ease: easing,
      },
      0,
    )
    .add('btnIconFrom')
    .fromTo(
      iconFrom,
      0.05,
      {
        scale: 1,
      },
      {
        autoAlpha: 0,
        scale: 0,
        ease: easing,
      },
      0,
    )
    .add('btnIconTo')
    .fromTo(
      iconTo,
      config.launcherAnimSpeed,
      {
        scale: 0,
      },
      {
        autoAlpha: 1,
        scale: 1,
        ease: easing,
      },
      0,
    )
}

export const createBtnAnimation = (target, from, to) => {
  if (isMobile()) {
    return null
  }
  return TweenLite.fromTo(target, 0.2, from, to)
}

export const minimizeChatBtnIn = (target) =>
  createBtnAnimation(
    target,
    {
      opacity: 0,
      x: 27,
    },
    {
      opacity: 1,
      x: 0,
      ease: easing,
    },
  )

export const minimizeChatBtnOut = (target) =>
  createBtnAnimation(
    target,
    {
      opacity: 1,
      x: 0,
    },
    {
      opacity: 0,
      x: 27,
      ease: easing,
    },
  )

export const startChatBtnIn = (target) =>
  createBtnAnimation(
    target,
    {
      opacity: 0,
      x: 27,
    },
    {
      opacity: 1,
      x: 0,
      ease: easing,
    },
  )

export const startChatBtnOut = (target) =>
  createBtnAnimation(
    target,
    {
      opacity: 1,
      x: 0,
    },
    {
      opacity: 0,
      x: 27,
      ease: easing,
    },
  )

export const endChatBtnIn = (target) =>
  createBtnAnimation(
    target,
    {
      opacity: 0,
      x: 27,
    },
    {
      opacity: 1,
      x: 0,
      ease: easing,
    },
  )

export const endChatBtnOut = (target) =>
  createBtnAnimation(
    target,
    {
      opacity: 1,
      x: 0,
    },
    {
      opacity: 0,
      x: 27,
      ease: easing,
    },
  )
